interface OptionItem {
	value: string;
	label: string;
}

export const UNDEFINED = "undefined";

export const TITLE_OPTIONS: OptionItem[] = [
	{
		value: "Mr",
		label: "Mr",
	},
	{
		value: "Mrs",
		label: "Mrs",
	},
	{
		value: "Ms",
		label: "Ms",
	},
	{
		value: "Miss",
		label: "Miss",
	},
	{
		value: "Other",
		label: "Other",
	},
];

export const VALID_TITLES = TITLE_OPTIONS.map(item => item.value);

export const INSURANCE_MONTHS_OPTIONS: OptionItem[] = [
	{
		value: "10",
		label: "Monthly - over 10 months",
	},
	{
		value: "12",
		label: "Monthly - 12 months",
	},
	{
		value: "1",
		label: "Annually - 12 months",
	},
];

export const MONTHS_OPTIONS: OptionItem[] = [
	{
		value: "jan",
		label: "January",
	},
	{
		value: "feb",
		label: "February",
	},
	{
		value: "mar",
		label: "March",
	},
	{
		value: "apr",
		label: "April",
	},
	{
		value: "may",
		label: "May",
	},
	{
		value: "jun",
		label: "June",
	},
	{
		value: "jul",
		label: "July",
	},
	{
		value: "aug",
		label: "August",
	},
	{
		value: "sep",
		label: "September",
	},
	{
		value: "oct",
		label: "October",
	},
	{
		value: "nov",
		label: "November",
	},
	{
		value: "dec",
		label: "December",
	},
];
